export * from './delete-objekt-art.command.module';
export * from './service';
export * from './component';